import React, { useState,useEffect } from 'react';
import {useAppDispatch,useAppSelector,} from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Tabs,Button,Space ,App,Pagination  } from 'antd';
import { eventBus } from '@/utils/eventBus';
import PostordersList from '../../components/PostordersList/PostordersList';
import styles from './PostOrders.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import img1 from '@/assets/images/001.png';
import img2 from '@/assets/images/002.png';
import img3 from '@/assets/images/003.png';
import img4 from '@/assets/images/004.png';
import { getEmergencyServiceList } from '@/api/order';
import { emergencyServiceOrderStatusOptionsMapper,serviceCarpoolOrderStatus } from '@/utils/constants';
import CarpoolService from './CarpoolService';
import { useNavigate,useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// 规格类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}

// 新的紧急服务数据类型
interface EmergencyServiceUser {
  user_id: string;
  merchant_id: string;
  first_name: string;
  last_name: string;
  nick_name: string;
  username: string;
  email: string;
  phone: string | null;
  photo: string | null;
  gender: number;
  birthday: string | null;
  level: number;
  is_delete: boolean;
  create_time: string;
  update_time: string;
}

interface EmergencyServiceImage {
  file_id: string;
  product_id: string | null;
  product_media_id: string | null;
  product_media_type: string;
  product_media_file_url: string;
  product_media_video_cover_id: string | null;
}

interface EmergencyServiceData {
  emergency_service_id: string;
  user: EmergencyServiceUser;
  service_category: any[];
  urgency_level: number;
  problem_description: string;
  budget: string;
  budget_price: string;
  latitude: string;
  longitude: string;
  city_state: string;
  address: string;
  phone: string;
  appointment_time: string;
  images: EmergencyServiceImage[];
  status: number;
  create_time: string;
  distance: number;
}
interface OrderListResponse {
  code: number;
  message: string;
  data: EmergencyServiceData[];
  total: number;
  totalPages: number;
  pageNum: number;
  pageSize: number;
}
//tabItems切换 
const generateTabItems = (t:(key:string)=>string) => {
  const orderStatusOptions = emergencyServiceOrderStatusOptionsMapper();
  const tabItems = [
    { label: t('common.All'), key: '' },
    ...orderStatusOptions.map(option => ({
      label: t('PostOrders.'+option.label),
      key: option.value.toString()
    }))
  ];
  
  return tabItems;
};
const PostOrders: React.FC = () => {
  const {message} = App.useApp();
  const dispatch = useAppDispatch();
  //国际化语言切换
  const { t, i18n } = useTranslation();
  const tabItems = generateTabItems(t);
  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state)=>state.searchBar.yourTownloopSearchValue);

  // 分类切换状态 - Emergency Service默认选中
  const [activeCategory, setActiveCategory] = useState('emergency');


   //tab切换
   const [activeTab, setActiveTab] = useState('');
   
   // 订单数据状态
   const [orders, setOrders] = useState<EmergencyServiceData[]>([]);
   const [loading, setLoading] = useState(false);
   const [pagination, setPagination] = useState({
     current: 1,
     pageSize: 10,
     total: 0,
     totalPages: 0
   });

  // 切换分类
  const handleCategoryChange = (category: string) => {
    setActiveCategory(category);
    setActiveTab('');
    // 切换分类时使用静态数据
    // setOrders(emergencyServiceData);
    // setPagination({
    //   current: 1,
    //   pageSize: pagination.pageSize,
    //   total: emergencyServiceData.length,
    //   totalPages: Math.ceil(emergencyServiceData.length / pagination.pageSize)
    // });
  };


  //获取订单页列表
  const getOrderPageListData = (pageNum: number = 1, pageSize: number = 10, status?: string) => {
    setLoading(true);
    const params: any = { page_num: pageNum, page_size: pageSize };
    if (status !== undefined) {
      params.status = status;
    }

    let api = getEmergencyServiceList;

    // if(activeCategory === 'delivery'){
    //   api = getCarpoolDeliveryOrderList;
    // }
    api(params).then((res: OrderListResponse) => {
      console.log(res, 'getOrderPageListData');
      if (res.code === 200) {
        // 转换数据格式
        // const transformedOrders = res.data.map(transformOrderData);
        setOrders(res.data);
        setPagination({
          current: res.pageNum,
          pageSize: res.pageSize,
          total: res.total,
          totalPages: res.totalPages
        });
      } else {
        message.error(res.message || 'Failed to get order list');
      }
    }).catch((error) => {
      console.error('Failed to get order list:', error);
      message.error('Failed to get order list');
    }).finally(() => {
      setLoading(false);
    });
  }



  //切换tab事件
  const changeTab = (key: string) => {
    console.log('key',key);
    
    setActiveTab(key);
    getOrderPageListData(1, pagination.pageSize, getOrderStatusText(Number(key)))
  }

  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  const searchAction = () => {
    console.log('searchValue',searchValue);
    if (!searchValue.trim()) {
      // 如果搜索框为空，显示所有数据
      // const orderStatus = activeTab === 'all' ? undefined : parseInt(activeTab);
      // let filteredData = emergencyServiceData;
      // if (orderStatus !== undefined) {
      //   filteredData = emergencyServiceData.filter(item => item.status === orderStatus);
      // }
      // setOrders(filteredData);
      // setPagination({
      //   current: 1,
      //   pageSize: pagination.pageSize,
      //   total: filteredData.length,
      //   totalPages: Math.ceil(filteredData.length / pagination.pageSize)
      // });
      return;
    }
    
    // 通过关键字搜索静态数据
    setLoading(true);
    const searchTerm = searchValue.trim().toLowerCase();
    // const filteredData = emergencyServiceData.filter(item => 
    //   item.problem_description.toLowerCase().includes(searchTerm) ||
    //   item.emergency_service_id.toLowerCase().includes(searchTerm) ||
    //   item.user.nick_name.toLowerCase().includes(searchTerm)
    // );
    
    // if (filteredData.length > 0) {
    //   setOrders(filteredData);
    //   setPagination({
    //     current: 1,
    //     pageSize: 10,
    //     total: filteredData.length,
    //     totalPages: Math.ceil(filteredData.length / 10)
    //   });
    // } else {
    //   setOrders([]);
    //   setPagination({
    //     current: 1,
    //     pageSize: 10,
    //     total: 0,
    //     totalPages: 0
    //   });
    // }
    setLoading(false);
  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }
  //获取商品id
  const [showServicePanel, setShowServicePanel] = useState(false);
  //分页change
  const paginationChange = (page: number, pageSize: number) => {
   
    getOrderPageListData(page, pageSize, undefined);
  }
  //mounted 和unmounted
  useEffect(()=>{
    return ()=>{
      console.log('Component destroyed');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  },[]);
  const params = useLocation(); // 获取URL参数
  // 订单状态映射函数
  const getOrderStatusText = (status: number): string => {
    
    let orderStatusOptions = null;
    if(params.pathname === "/yourtownloop/serviceorders"){
      orderStatusOptions = serviceCarpoolOrderStatus()
    }else {
      orderStatusOptions = emergencyServiceOrderStatusOptionsMapper()
    }
    // console.log("params",params,orderStatusOptions,serviceCarpoolOrderStatus(),emergencyServiceOrderStatusOptionsMapper())
    const statusOption = orderStatusOptions.find(option => option.value === status);
    return statusOption?.label || 'Unknown Status';
  };
    //yourTownloopSearchValue关键字的监听
  useEffect(()=>{
    console.log('YourOrders component yourTownloopSearchValue',yourTownloopSearchValue);
   
   },[yourTownloopSearchValue])
  useEffect(() => {
    getOrderPageListData(1, 10, '');
  }, []);

  return (
    <div className={styles['order-box']}> 
      {!showServicePanel && (
        <div className={styles['left-panel']}>
          {/* 分类切换table */} 
          <div className={styles['category-switch-container']}>
            <div className={styles['category-switch']}>
              <div 
                className={`${styles['category-tab']} ${activeCategory === 'emergency' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('emergency')}
              >
                {t('PostOrders.emergencyService')}
              </div>
              <div 
                className={`${styles['category-tab']} ${activeCategory === 'carpool' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('carpool')}
              >
                {t('PostOrders.RideBoard')}
              </div>
            </div>
          </div>
                  
          {/* 根据分类显示不同内容 */}
          {activeCategory === 'carpool' ? (
            <>
              <CarpoolService />
            </>
            
          ) : (
            <>
              <Tabs
                className={styles['favorites-tabs']}
                items={tabItems}
                activeKey={activeTab}
                onChange={changeTab}
              />
              <div className={styles['search-btn-box']}>
                <div className={styles['sidebar-search']}>
                  <input
                    value={searchValue}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                    onKeyDown={searchHandleKeyDown}
                    type="text"
                    placeholder={t('postorders.title/ordernumber/storename')}
                  />
                  <img src={iocn2} alt="" onClick={searchAction}/>
                </div>
                <Button onClick={searchAction} className={styles['search-btn']}>{t('common.Search')}</Button>
              </div>
              <PostordersList orders={orders}/>
              <div className={styles['pagination-box']}>
                <Pagination 
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onChange={paginationChange}
                  showSizeChanger={false}
                  showQuickJumper
                  showTotal={(total, range) => `${t('common.Items')}：${range[0]}/${range[1]} ${t('common.Total')}：${total}`}
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PostOrders; 